import {
  AccordionItem,
  AccordionButton,
  AccordionIcon,
  AccordionPanel,
  TableContainer,
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Box,
  Accordion,
} from "@chakra-ui/react";
import { SiteData } from "../../types/site";

export function SitesDescription({ sites }: { sites: SiteData[] }) {
  return (
    <Accordion allowMultiple>
      <AccordionItem>
        <h2>
          <AccordionButton bg="brand">
            <Box as="span" flex="1" textAlign="left">
              Sites Details
            </Box>
            <AccordionIcon />
          </AccordionButton>
        </h2>

        <AccordionPanel>
          <TableContainer whiteSpace={"normal"}>
            <Table variant="striped" size="sm" colorScheme="darkBrown">
              <Thead>
                <Tr>
                  <Th>Site</Th>
                  <Th>Description</Th>
                  <Th>Purpose</Th>
                </Tr>
              </Thead>
              <Tbody>
                {sites.map(({ siteName, locationDescription, purpose }) => (
                  <Tr key={siteName}>
                    <Td whiteSpace={"nowrap"} verticalAlign={"top"}>
                      {siteName}
                    </Td>
                    <Td verticalAlign={"top"}>{locationDescription}</Td>
                    <Td>{purpose}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        </AccordionPanel>
      </AccordionItem>
    </Accordion>
  );
}
